import ApiLibrary from "./ApiLibrary";

class RecruiterFinancialMetric extends ApiLibrary.Base {
  static className = "RecruiterFinancialMetric";

  static define() {}
}

export default ApiLibrary.createResource(RecruiterFinancialMetric);
